import { entries } from "@/mocks/home";

type EntryStatusProps = {
  onNotify: (message: string) => void;
};

const statusMap = {
  smooth: { label: "畅通", dot: "bg-secondary-500", chip: "bg-secondary-100 text-secondary-900" },
  busy: { label: "拥挤", dot: "bg-accent-500", chip: "bg-accent-100 text-accent-900" },
  maintain: { label: "维护中", dot: "bg-primary-500", chip: "bg-primary-100 text-primary-800" },
};

export default function EntryStatus({ onNotify }: EntryStatusProps) {
  return (
    <section id="entries" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">
              ENTRY STATUS
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              实时入口与备用地址
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              下列线路由系统每 5 分钟自动校验一次，展示的是当前可用的访问路径。爱黑料网入口与备用地址状态一目了然，建议同时保存两条以上。
            </p>
          </div>
          <button
            type="button"
            onClick={() => onNotify("已重新校验全部线路，状态已刷新")}
            className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            <i className="ri-refresh-line text-base text-primary-600"></i>
            重新校验线路
          </button>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:mt-14 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {entries.map((entry) => {
            const status = statusMap[entry.status];
            return (
              <div
                key={entry.id}
                className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-100/70 p-5 transition-transform duration-300 hover:-translate-y-1"
              >
                <div>
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-label rounded-md bg-background-50 px-2.5 py-1 text-xs text-foreground-600">
                      {entry.tag}
                    </span>
                    <span
                      className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${status.chip}`}
                    >
                      <span className={`h-1.5 w-1.5 rounded-full ${status.dot}`}></span>
                      {status.label}
                    </span>
                  </div>
                  <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
                    {entry.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{entry.note}</p>
                </div>

                <div className="mt-6 flex items-end justify-between gap-3 border-t border-background-200 pt-4">
                  <div>
                    <p className="text-xs text-foreground-500">平均响应</p>
                    <p className="mt-1 font-heading text-lg font-bold text-foreground-900">
                      {entry.latency}
                      <span className="ml-2 text-xs font-normal text-foreground-500">
                        {entry.speed}
                      </span>
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      entry.status === "maintain"
                        ? onNotify("该线路正在维护升级，请先使用其他线路")
                        : onNotify(`${entry.name}已复制，粘贴到浏览器即可访问`)
                    }
                    className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3.5 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-foreground-800"
                  >
                    <i className="ri-file-copy-line text-sm"></i>
                    复制
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}